// Single source of truth for account route paths.
// See docs/migration-rules.md §5.

export const ACCOUNT_BILLING = '/account/billing' as const
export const ACCOUNT_BILLING_CARD_CREATE = `${ACCOUNT_BILLING}/card/create` as const
export const ACCOUNT_BILLING_CARD_EDIT_ROOT = `${ACCOUNT_BILLING}/card/edit` as const
export const ACCOUNT_BILLING_CREDIT_EDIT = `${ACCOUNT_BILLING}/credit/edit` as const
export const ACCOUNT_BILLING_DBWS = `${ACCOUNT_BILLING}/dbws` as const
export const ACCOUNT_BILLING_DEBIT_CREATE = `${ACCOUNT_BILLING}/debit/create` as const
export const ACCOUNT_BILLING_DEBIT_VIEW_ROOT = `${ACCOUNT_BILLING}/debit/view` as const
export const ACCOUNT_BILLING_SECTION_DBWS = 'dbws' as const

export const accountBillingCardEditPath = (billingInfoId: string) => `${ACCOUNT_BILLING_CARD_EDIT_ROOT}/${billingInfoId}`
export const accountBillingDebitViewPath = (paymentAccountId: number) => `${ACCOUNT_BILLING_DEBIT_VIEW_ROOT}/${paymentAccountId}`

export const ACCOUNT_ORDERS = '/account/orders' as const
export const accountOrderPath = (orderId: string | number) => `${ACCOUNT_ORDERS}/${orderId}`
export const accountOrderReceiptPath = (orderId: string | number) => `${accountOrderPath(orderId)}/receipt`
export const ACCOUNT_PAYMENT = '/account/payment' as const
export const ACCOUNT_PAYMENT_CREATE = `${ACCOUNT_PAYMENT}/create` as const
export const accountPaymentEditPath = (paymentId: string | number) => `${ACCOUNT_PAYMENT}/edit/${paymentId}`

export const ACCOUNT_SUBSCRIPTIONS = '/account/subscriptions' as const
export const ACCOUNT_SUBSCRIPTIONS_CLAIM = `${ACCOUNT_SUBSCRIPTIONS}/claim` as const
export const ACCOUNT_SUBSCRIPTIONS_REDEEM = `${ACCOUNT_SUBSCRIPTIONS}/redeem` as const
